import * as React from 'react'
import { Route, RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import AddFundsModal from '../../../../containers/riders/riderdetails/AddFundsModal'
import AddBonusModal from '../../../../containers/riders/riderdetails/AddBonusModal'
import AutochargeModal from '../../../../containers/riders/riderdetails/AutochargeModal'
import WalletBalance from '../../../../containers/riders/riderdetails/WalletBalance'
import AddCardModal from '../../../../containers/riders/riderdetails/AddCardModal'
import RefundTransactionModal from 'src/containers/riders/riderdetails/RefundTransactionModal'
import { IPaymentSourceResponseDTO, IRiderObject, IOrgCreateObj, IRefundTransactionDTO } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import GearIcon from '../../../icons/ui/GearIcon'
import PaymentMethodItem from './PaymentMethodItem'
import WalletTransactionList from './WalletTransactionList'
import { BALANCE_TYPES, walletExportHeaders } from '../../../../constants/wallet'
import HorizontalSelector from '../../../HorizontalSelector'
import HorizontalSelectorItem from '../../../HorizontalSelectorItem'
import WalletTransactionHistoryList from './WalletTransactionHistoryList'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IWalletPaneProps extends RouteComponentProps<any> {
  rider: IRiderObject
  organizations: IOrgCreateObj | null
  currentUserId: string
  getRiderWallet: (id: string) => void
  getRiderWalletTransactions: (id: string) => void
  getRiderWalletTransactionHistory: (id: string) => void
  getRiderAutochargeConfig: (id: string) => void
  assignRefundDetails: (params: IRefundTransactionDTO) => void
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => void
}

interface IWalletPaneState {
  fullHistory: boolean
  timeFormat: string
}

class WalletPane extends React.Component<IWalletPaneProps, IWalletPaneState> {
  public state: IWalletPaneState = {
    fullHistory: false,
    timeFormat: 'MM.DD.YYYY h:mmA'
  }

  constructor(props: any) {
    super(props)
  }

  public componentDidMount() {
    if (this.props.rider && !this.props.rider.walletTransactions) {
      this.props.getRiderAutochargeConfig(this.props.rider.id)
      this.props.getRiderWalletTransactions(this.props.rider.id)
      this.props.getRiderWalletTransactionHistory(this.props.rider.id)
    }
  }

  public componentDidUpdate(prevProps: IWalletPaneProps) {
    if (this.props.rider && !this.props.rider.walletTransactions) {
      this.props.getRiderAutochargeConfig(this.props.rider.id)
      this.props.getRiderWalletTransactions(this.props.rider.id)
      this.props.getRiderWalletTransactionHistory(this.props.rider.id)
    }
    if (prevProps.organizations !== this.props.organizations) {
      const orgTimeFormat = this.props.organizations ? this.props.organizations.timeFormat : null
      const timeFormat = orgTimeFormat === 'mil' ? 'M/D/YYYY HH:mm' : 'M/D/YYYY hh:mmA'
      this.setState({
        timeFormat
      })
    }
  }

  public render() {
    const { rider } = this.props
    if (!rider) {
      return null
    }
    console.log('rendering wallet pane: ', rider)

    const addFundsModal = (props: any) => {
      return <AddFundsModal rider={rider} {...props} />
    }
    const autochargeModal = (props: any) => {
      return <AutochargeModal rider={rider} {...props} />
    }
    const addBonusModal = (props: any) => {
      return <AddBonusModal rider={rider} {...props} />
    }
    const addCardModal = (props: any) => {
      return <AddCardModal rider={rider} {...props} />
    }

    const refundTransactionModal = (props: any) => {
      return <RefundTransactionModal path={this.props.match.path} rider={rider} />
    }
    const autocharge = this.props.rider && this.props.rider.walletAutocharge
    const balance = rider && rider.wallet ? rider.wallet.wallet.balance / 100 : 0
    const riderWalletTransactions = rider && rider.walletTransactionHistory ? rider.walletTransactionHistory : []
    return (
      <section>
        <Route path={`${this.props.match.path}/add-funds`} render={addFundsModal} />
        <Route path={`${this.props.match.path}/add-funds/add-card`} render={addCardModal} />
        <Route path={`${this.props.match.path}/add-bonus`} render={addBonusModal} />
        <Route path={`${this.props.match.path}/auto-charge`} render={autochargeModal} />
        <Route path={`${this.props.match.path}/refund-transaction`} render={refundTransactionModal} />
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section full-section'>
            {/* TOP */}
            <div className='wallet-header'>
              {/* TITLE */}
              <div>
                <div className='h4 font-grey3 bold'>{UIMessages.common.walletBalance}</div>
                <Link to={`${this.props.match.path}/auto-charge`}>
                  <div title='Change Auto Charge' style={{ cursor: 'pointer' }} className='h6 font-grey2 weight-400'>
                    {UIMessages.common.autoChargeIs + ' '}
                    <span className={'uppercase h5'}>
                      {autocharge && autocharge.isEnabled ? UIMessages.common.on : UIMessages.common.off}
                    </span>
                    <GearIcon className='ml1 icon--12x12' />
                  </div>
                </Link>
              </div>
              {/* FUNDS */}
              <div className='ml4 flex'>
                <div>
                  <WalletBalance
                    rider={rider}
                    riderId={rider.id}
                    balanceType={BALANCE_TYPES.WALLET}
                    actionUrl={`${this.props.match.url}/add-funds`}
                  />
                </div>
                <div className='ml2'>
                  <WalletBalance
                    rider={rider}
                    riderId={rider.id}
                    balanceType={BALANCE_TYPES.BONUS}
                    actionUrl={`${this.props.match.url}/add-bonus`}
                  />
                </div>
              </div>
            </div>
            {/* SAVED PAYMENT Methods */}
            <div className='mt3'>
              <div className='font-grey2 bold h5 mb1'>{UIMessages.common.savedPaymentMethods}</div>
              <div className='flex flex-row'>
                {/* TODO: add pagination */}
                {rider &&
                  rider.wallet &&
                  rider.wallet.sources &&
                  Object.keys(rider.wallet.sources).map((item, i) => (
                    <PaymentMethodItem
                      onSelectPaymentMethod={this.onSelectPaymentMethod}
                      removeRiderPaymentSource={this.props.removeRiderPaymentSource}
                      riderId={rider.id}
                      key={`tmli-${i}`}
                      method={rider.wallet.sources[item]}
                    />
                  ))}
                {rider.wallet.sources.length === 0 && (
                  <div className='payment-source-item default'>
                    <div className='font-grey2 bold h5 pb2 pt2 center'>No Existing Payment Method Yet</div>
                  </div>
                )}
              </div>
            </div>
            {/* WALLET TRANSACTIONS */}
            <div className='mt2'>
              <div className='pt3 border-top'>
                <div className='flex mb3 items-center'>
                  <div>
                    <HorizontalSelector>
                      <HorizontalSelectorItem isSelected={!this.state.fullHistory}>
                        <div className='uppercase cursor--pointer' onClick={this.toggleTab(false)}>
                          {UIMessages.common.walletTransactions}
                        </div>
                      </HorizontalSelectorItem>
                      <HorizontalSelectorItem isSelected={this.state.fullHistory}>
                        <div className='uppercase cursor--pointer' onClick={this.toggleTab(true)}>
                          {UIMessages.common.fullHistory}
                        </div>
                      </HorizontalSelectorItem>
                    </HorizontalSelector>
                  </div>
                  <div style={{ flex: 1 }}>&nbsp;</div>
                  <CSVLink
                    data={riderWalletTransactions}
                    headers={walletExportHeaders}
                    filename={`${rider.firstName} ${rider.lastName}-${moment().format('YYYY-MM-DD')}`}
                  >
                    <div className='SubmitButton btn bg-green rounded font-white weight-300 h5'>Export</div>
                  </CSVLink>
                </div>
              </div>
              {!this.state.fullHistory ? (
                <div className='h4 font-grey2 bold wallet-transaction-list-container'>
                  <WalletTransactionList
                    rider={rider}
                    timeFormat={this.state.timeFormat}
                    currentUserId={this.props.currentUserId}
                    assignRefundDetails={this.props.assignRefundDetails}
                    path={this.props.match.path}
                  />
                </div>
              ) : (
                <div className='h4 font-grey2 bold'>
                  <WalletTransactionHistoryList rider={rider} timeFormat={this.state.timeFormat} />
                </div>
              )}
            </div>
          </div>
        </FloatingForm>
      </section>
    )
  }

  private toggleTab = (showFullHistory: boolean) => {
    return (e: any) => {
      this.setState({ fullHistory: showFullHistory })
    }
  }

  private onSelectPaymentMethod = (method: IPaymentSourceResponseDTO) => {
    const methods = Object.assign(
      [],
      this.props.rider && this.props.rider.wallet.sources
    ) as IPaymentSourceResponseDTO[]
    for (const id of Object.keys(methods)) {
      methods[id].default = method.id === methods[id].id
    }
    // TODO: Add actual save method. This change is not being saved
  }
}

export default WalletPane



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletPane.tsx